module.exports = __webpack_public_path__ + "img/icon-prev-black.237f5bce.svg";